import { Flight } from './flight';
import { Dashboard } from './dashboard';
import { CodeFormat } from './codeFormat';
import { Airport } from './airport';

import { parseFlightTime, formatFlightTime } from 'utils/format';
import { getPredictedTimeAlert } from 'utils/alerts';

export class FlightTableRow {
    dashboard: Dashboard;
    ident: CodeFormat;
    operator: CodeFormat;
    registration: string;
    origin: Airport;
    destination: Airport;
    estimatedOnUnixTime: number | undefined;
    predictedOnUnixTime: number | undefined;
    estimatedInUnixTime: number | undefined;
    predictedInUnixTime: number | undefined;

    get airlineIconUrl(): string {
        return `https://flightaware.com/images/airline_logos/90p/${this.operator.icao}.png`;
    }

    get predictedOnDifference(): number | undefined {
        if (this.estimatedOnUnixTime == null || this.predictedOnUnixTime == null) {
            return undefined;
        }
        return this.predictedOnUnixTime - this.estimatedOnUnixTime;
    }

    get predictedInDifference(): number | undefined {
        if (this.estimatedInUnixTime == null || this.predictedInUnixTime == null) {
            return undefined;
        }
        return this.predictedInUnixTime - this.estimatedInUnixTime;
    }

    get estimatedOn(): string {
        return formatFlightTime(this.estimatedOnUnixTime, this.dashboard.timezone, this.destination.tz);
    }
    get predictedOn(): string {
        return formatFlightTime(this.predictedOnUnixTime, this.dashboard.timezone, this.destination.tz);
    }
    get estimatedIn(): string {
        return formatFlightTime(this.estimatedInUnixTime, this.dashboard.timezone, this.destination.tz);
    }
    get predictedIn(): string {
        return formatFlightTime(this.predictedInUnixTime, this.dashboard.timezone, this.destination.tz);
    }

    hasAlert(alertThresholdEarly: number, alertThresholdLate: number): boolean {
        const predictedInAlert = getPredictedTimeAlert(
            this.estimatedInUnixTime,
            this.predictedInUnixTime,
            alertThresholdEarly,
            alertThresholdLate
        );
        const predictedOnAlert = getPredictedTimeAlert(
            this.estimatedOnUnixTime,
            this.predictedOnUnixTime,
            alertThresholdEarly,
            alertThresholdLate
        );
        return predictedInAlert !== 'none' || predictedOnAlert !== 'none';
    }

    constructor(flight: Flight, dashboard: Dashboard) {
        this.dashboard = dashboard;
        this.ident = flight.ident;
        this.operator = flight.operator;
        this.registration = flight.registration;
        this.origin = flight.origin;
        this.destination = flight.destination;
        this.estimatedOnUnixTime = parseFlightTime(flight.estimated.on);
        this.predictedOnUnixTime = parseFlightTime(flight.predicted.on);
        this.estimatedInUnixTime = parseFlightTime(flight.estimated.in);
        this.predictedInUnixTime = parseFlightTime(flight.predicted.in);
    }
}
